import { URLS } from '@/configs/urls'

export const TASKS_TAB_QUERY_KEY = 'tab'

export type TasksView = 'explore' | 'my'

export type TasksMyStatus =
  | 'all'
  | 'actionRequired'
  | 'frozen'
  | 'inProgress'
  | 'ended'

export const TASKS_MY_STATUSES: readonly TasksMyStatus[] = [
  'all',
  'actionRequired',
  'frozen',
  'inProgress',
  'ended'
]

export type TasksListState = {
  view: TasksView
  myStatus: TasksMyStatus
}

export const TASKS_LIST_DEFAULT_STATE: TasksListState = {
  view: 'explore',
  myStatus: 'all'
}

// `active` / `closed` are the tab values from before the feed redesign;
// they stay so old links keep landing on the same list.
const MY_STATUS_TAB: Record<TasksMyStatus, string> = {
  all: 'my',
  actionRequired: 'action-required',
  frozen: 'frozen',
  inProgress: 'active',
  ended: 'closed'
}

const TAB_TO_MY_STATUS = Object.fromEntries(
  Object.entries(MY_STATUS_TAB).map(([status, tab]) => [tab, status])
) as Record<string, TasksMyStatus>

/** Path to tasks list; Explore is the default and omits `?tab=`. */
export function tasksListPath(state?: TasksListState): string {
  if (!state || state.view === 'explore') {
    return URLS.TASKS
  }
  return `${URLS.TASKS}?${TASKS_TAB_QUERY_KEY}=${MY_STATUS_TAB[state.myStatus]}`
}

export function parseTasksTabParam(
  value: string | null | undefined
): TasksListState {
  const myStatus = value ? TAB_TO_MY_STATUS[value] : undefined
  if (myStatus) {
    return { view: 'my', myStatus }
  }
  return TASKS_LIST_DEFAULT_STATE
}
